import React, { useState } from 'react';
import moment from 'moment';
import 'moment/locale/es';

import { useForm } from '../../../hooks/useForm';
import { formValidation } from '../../../helpers/formValidation';
import { useDispatch, useSelector } from 'react-redux';
import { generatePagoEfectivo } from '../../../actions/payments';

export const Tienda = () => {

    const dispatch = useDispatch();
    const {tiendaForm} = useSelector(state => state.forms);
    const {in_process} = useSelector(state => state.payments);
    const [{inputCantidad}, handleInputChange, reset] = useForm({
        inputCantidad: ''
    })
    const [cantidad, setCantidad] = useState(0);

    const handleCantidad = (e) =>{
        handleInputChange(e);
        if(!!e.target.value)
            setCantidad(Math.round(e.target.value * 1.03364 + 2.5*1.16));
        else
            setCantidad(0);
    }

    const handleReset = () => {
        reset();
        setCantidad(0);
    }

    const handleSubmit=(e)=>{
        formValidation(e, () => dispatch(generatePagoEfectivo(inputCantidad, e.target.name, 'store', handleReset)));
    }

    return (
        <div>
            <form 
                name="tiendaForm" 
                className="needs-validation needs-validation" 
                noValidate={true} 
                onSubmit={handleSubmit}
            >
                <p>Genera y consultar tus fichas de pagos vigentes para pagar en <strong>Comercio</strong>.</p>
                <h6 className="text-warning">Está forma de pago genera una comisión bancaria del 2.9% + $2.5 MXN más IVA por el procesamiento de este tipo de transacción, aparte el comercio puede cobrarte algun otro tipo de comisión.</h6>
                <div className="row">
                    <div className="col">
                        <img className="w-100" src={`${process.env.REACT_APP_API_URL}/assets/images/tiendas.png`} alt="tiendas"/>
                    </div>
                </div>
                {
                    !!tiendaForm.msg &&
                        <div className={`alert alert-${tiendaForm.error?'danger':'success'}`} role="alert">
                            {tiendaForm.msg}
                        </div>
                }
                <div className="row mt-2">
                    <div className="col-md-6">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text" id="inputGroupPrepend">$</span>
                            </div>
                            <input 
                                type="text" 
                                className="form-control" 
                                placeholder="Cantidad a abonar" 
                                aria-describedby="inputGroupPrepend" 
                                name="inputCantidad"
                                value={inputCantidad}
                                onChange={handleCantidad}
                                required={true} 
                            />
                            <div className="invalid-feedback">
                                Ingresa una cantidad.
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 text-center">
                        <h6>Total con comisión:</h6>
                        <h5 className="text-success">
                            { new Intl.NumberFormat("en-US", {style: "currency", currency: "MXN"}).format(cantidad) }
                        </h5>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col d-flex align-content-center justify-content-center">
                        <button 
                            className="btn btn-primary" 
                            type="submit"
                            disabled={!!tiendaForm.loading ? true : false}
                        >
                            {!!tiendaForm.loading && <i className="spinner-border spinner-border-sm" role="status"></i>} Generar ficha de pago
                        </button>
                    </div>
                </div>
                <div className="table-responsive-md mt-4" style={{overflowY: 'hidden'}}>
                    <table className="table table-hover table-centered text-nowrap">
                        <thead className="text-center">
                            <tr>
                                <th>Cantidad</th>
                                <th>Vencimiento</th>
                                <th>Creación</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                in_process.map((payment, pk) => ( payment.method === 'store' &&
                                    <tr className="animate__animated animate__fadeInUp" key={pk}>
                                        <td>
                                            <a 
                                                href={`${process.env.REACT_APP_API_URL}/pdf/pagoEfectivo/tienda/${payment.payment_id}`}
                                                className="text-success" 
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className="fas fa-arrow-circle-down" style={{fontSize: 20}}></i>
                                            </a>
                                            &nbsp;{ new Intl.NumberFormat("en-US", {style: "currency", currency: "MXN"}).format(Math.round(payment.amount * 1.03364 + 2.5*1.16)) }
                                        </td>
                                        <td className="text-center">{ moment(payment.due_date).format('DD/MMM/YY') }</td>
                                        <td className="text-center"><h5 className="m-0 font-weight-normal">{moment(payment.creation_date).format('DD/MMM/YY')}</h5></td>

                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </form>
        </div>
    )
}
